import '.go{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.gp{padding-left:1.5rem;}.ssr-plugin'
import '.gq{margin:1rem 0;}.ssr-plugin'
import '.gr{color:var(--gray-700);}.ssr-plugin'
import '.gs{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="go gp gq gr gs"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
